import * as types from "../ActionType";
import axios from "axios";
import { notifyError ,notifysuccess, staticc } from "../../Components/General/Notification";

const getReviews = (allreviwes) => {
    return ({
        type: types.GET_ALL_REVIEWS,
        payload: allreviwes
    })
}

const editstatusRev = () => {
    return ({
        type: types.EDIT_STATUS_REVIEWS
    })
}

const delRev = () => {
    return ({
        type: types.DELETE_REVIEW
    })
}

const delReel = () => {
    return ({
        type: types.DELETE_REELS
    })
}

const getReels = (allReels) => {
    return ({
        type: types.GET_ALL_REELS,
        payload: allReels
    })
}

const addReel = () => {
    return ({
        type: types.ADD_REELS
    })
}

export const loadReviews = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/vendor-reviews`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getReviews(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const editStatusReview = (id, status,setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        console.log(id)
        console.log(status)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/review-change-status`, { id, status }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editstatusRev());
                dispatch(loadReviews());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data)
        })
    }
}

export const deleteReview = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/delete-review`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delRev());
                dispatch(loadReviews());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const loadReels = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/reels`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getReels(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const postReel = (vendor_id,title, description, video,setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append('vendor_id', vendor_id);
        Dataa.append('title', title);
        Dataa.append('description', description);
        Dataa.append('video', video);
        axios.post(`${staticc}/api/reel-store`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addReel());
                dispatch(loadReels());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const deleteReel = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/reel-delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delReel());
                dispatch(loadReels());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}